import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["vacationFrom", "vacationTill", "vacationDays", "submitBtn", "textOutput", "notEnoughDaysOutput"];

    static values = {
        holidaysLeft: Number,
    }

    connect() {
        this.vacationFromTarget.addEventListener('change', ()=>{
            this.updateSelectedDays();
        });

        this.vacationTillTarget.addEventListener('change', ()=>{
            this.updateSelectedDays();
        });

        this.modalElement = this.element.closest('.modal');
        if (this.modalElement) {
            this._onModalShown = () => this.resetState();
            this.modalElement.addEventListener('modal:shown', this._onModalShown);
        }
    }

    disconnect() {
        if (this.modalElement && this._onModalShown) {
            this.modalElement.removeEventListener('modal:shown', this._onModalShown);
        }
    }

    resetState() {
        this.vacationDaysTarget.textContent = 0;
        this.notEnoughDaysOutputTarget.classList.add('d-none');
        this.enableSubmitButton();
    }

    updateSelectedDays() {
        const bothDatesSelected = !!this.vacationFromTarget.value && !!this.vacationTillTarget.value;

        const fromDate = new Date(this.vacationFromTarget.value);
        const tillDate = new Date(this.vacationTillTarget.value);

        // Calculate the number of days between fromDate and tillDate
        const diffTime = tillDate - fromDate;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

        // Update the vacationDays span with the calculated days count
        if (bothDatesSelected && diffDays > 0) {
            this.vacationDaysTarget.textContent = diffDays.toString();
        } else {
            this.vacationDaysTarget.textContent = 0;
        }

        if (!bothDatesSelected) {
            this.notEnoughDaysOutputTarget.classList.add("d-none");
            return;
        }

        const notEnoughDays = diffDays > this.holidaysLeftValue;
        this.notEnoughDaysOutputTarget.classList.toggle("d-none", !notEnoughDays);

        if (diffDays < 7 || notEnoughDays) {
            this.disableSubmitButton();
        } else {
            this.enableSubmitButton();
        }
    }

    disableSubmitButton() {
        this.submitBtnTarget.disabled = true;
        this.submitBtnTarget.style.color = "#686767"
        this.submitBtnTarget.style.backgroundColor = "#cccccc";
        this.submitBtnTarget.style.cursor = "not-allowed";
    }

    enableSubmitButton() {
        this.submitBtnTarget.disabled = false;
        this.submitBtnTarget.style.color = "white"
        this.submitBtnTarget.style.backgroundColor = "#58c8ff";
        this.submitBtnTarget.style.cursor = "pointer";
    }
}
